import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import SuccessStories from "@/pages/SuccessStories";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const Protected = ({ children }) =>
  localStorage.getItem("bs_token") ? children : <Navigate to="/admin/login" replace />;

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/success-stories" element={<SuccessStories />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
        </Routes>
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
